import SettingsBackupRestore from "@mui/icons-material/SettingsBackupRestore"
import { Box, styled } from "@mui/material"

const IconContainer = styled(Box)({
  borderRadius: "50%",
  color: "white",
  backgroundColor: "red",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
})

const SettingsBackupRestoreCustomized = ({ width = 30, height = 30, ...props }) => (
  <IconContainer sx={{ width, height }}>
    <SettingsBackupRestore {...props} />
  </IconContainer>
)

export default SettingsBackupRestoreCustomized
